import React, { useContext } from 'react'
import AppContext from 'context/app'
import useNavHeight from 'hooks/useNavHeight'
import { Categories } from './bar'
import { Overlays } from 'components/nav/overlay'
import { motion, AnimatePresence } from 'motion/react'
import chevronRight from 'svgs/chevron-right-black.svg'

export default function NavMobile() {
    const MAX_WIDTH = 430
    const NAV_BORDER_WIDTH = 0

    const { overlay, subMenu, setSubmenu } = useContext(AppContext)
    const height = useNavHeight()
    
    return (
        <div
            id='nav-mobile'
            className='d-flex j-end p-fixed w-100 l-0 z-nav'
            style={{
                top: height + NAV_BORDER_WIDTH,
                transitionDelay: overlay === 'Mobile' ? '0ms' : '250ms',
                height: overlay === 'Mobile' ? `calc(100vh - ${height}px)` : 0,
            }}
        >
            <div 
                id='mobile-overlay'
                className='p-relative w-100 t-500'
                style={{
                    right: overlay === 'Mobile' ? 0 : -MAX_WIDTH,
                    height: `calc(100vh - ${height}px - ${NAV_BORDER_WIDTH}px)`,
                }}
                css={{
                    maxWidth: MAX_WIDTH,
                    overflowY: 'auto',
                    overflowX: 'hidden',
                }}
            >
                <AnimatePresence>
                    <motion.div
                        key={subMenu}
                        className='p-absolute w-100'
                        animate={{ right: 0 }}
                        initial={{ right: subMenu ? -MAX_WIDTH : MAX_WIDTH }}
                        exit={{ right: subMenu ? -MAX_WIDTH : MAX_WIDTH }}
                        transition={{ type: 'tween', ease: 'linear', duration: .25 }}
                    >
                        {
                            subMenu ?
                                    <div>
                                        <button
                                            onClick={() => setSubmenu('')}
                                            className='b-0 bg-0 p-4 w-100 d-flex j-between pointer'
                                            css={{
                                                '::after': { display: 'none' }
                                            }}
                                        >
                                            
                                            <img src={chevronRight} alt="" style={{ transform: 'rotate(180deg)' }} />
                                            <h4 className='black sm'>{subMenu}</h4>
                                            <div style={{ width: 0 }} />
                                        </button>
                                        <div css={{ padding: 16 }}>
                                            {Overlays(subMenu, true)}
                                        </div>
                                    </div>
                                :
                                <Categories
                                    isMobile
                                    className='d-flex f-column'
                                />
                        }
                    </motion.div>
                </AnimatePresence>
            </div>
        </div>
    )
}
